define('apps/course-intro/views/regions/levels/content',[
    'apps/course-intro/templates/regions/levels/content',
    'apps/course-intro/views/regions/levels/level-grid',
    'components/asset-player/main',
    'components/transition/transition'
], function (template, LevelGridView, assetPlayer, Transition) {
    "use strict";

    return Mn.LayoutView.extend({

        "template": template,

        "regions": {
            "grid": ".levels"
        },

        "onRender": function () {
            this.showChildView('grid', new LevelGridView({
                "collection": this.model.get("levels")
            }));
            assetPlayer.channel.command(assetPlayer.channel.Event.RENDER, {
                "target": this.$el
            });
        },

        "onShow": function () {
            Transition.create({
                "direction": Transition.Direction.LEFT,
                "context": this,
                "el": $('.hero h1', this.el),
                "type": Transition.Type.FADE_IN,
                "duration": 0.8
            }).start();

            Transition.create({
                "direction": Transition.Direction.NONE,
                "context": this,
                "el": $('.infographic.spend', this.el),
                "type": Transition.Type.FADE_IN,
                "duration": 0.8,
                "delay": 0.8
            }).start();

            Transition.create({
                "direction": Transition.Direction.RIGHT,
                "context": this,
                "el": $('.infographic.interest', this.el),
                "type": Transition.Type.FADE_IN,
                "duration": 0.8,
                "delay": 1.2
            }).start();
        },

        "serializeData": function () {
            var data = Mn.ItemView.prototype.serializeData.apply(this, arguments);

            _.each(data.levels, function (level, index) {
                level.levelNum = index + 1;
            });

            return data;
        }
    });
});

